import { SxProps, Theme } from '@mui/material'
import { ColumnMeta } from '@tanstack/react-table'

import { CELL_HEIGHT } from 'components/Table/constants'

export const cellWrapperStyles = <T>(meta?: ColumnMeta<T, unknown>): SxProps<Theme> => {
  const centered = Boolean(meta?.centered)

  return {
    alignItems: 'center',
    color: 'inherit',
    display: 'flex',
    justifyContent: centered ? 'center' : undefined,
    minHeight: CELL_HEIGHT,
    p: 2,
    textDecoration: 'none',
  }
}
